export enum CardSidesEnum {
  FRONT = 'front',
  BACK = 'back',
}
